<div class="layout-topbar">
  <div class="layout-topbar-start">
    <a [routerLink]="['/']" class="layout-topbar-logo">
      <img [src]="'assets/layout/images/logos/clearbasin_horizontal_2-color_01.png'" alt="clearbasin_horizontal_1"
           class="h-3rem" loading="lazy">
    </a>
    <a #menuButton (click)="onMenuButtonClick()" class="layout-menu-button" pRipple>
      <i class="pi pi-chevron-right"></i>
    </a>

    <a #mobileMenuButton (click)="onMobileTopbarMenuButtonClick()" class="layout-topbar-mobile-button" pRipple>
      <i class="pi pi-ellipsis-v"></i>
    </a>
  </div>

  <div class="layout-topbar-end">
    <!---- Enviornment Type  ----->
    <env-type></env-type>
    <div class="layout-topbar-actions-end">
      <ul class="layout-topbar-items">
        <li *ngIf="!isInternalView">
          <a (click)="getNavigateToDocumentationView()" [pTooltip]="'Internal Documentation'" [tooltipPosition]="'left'"
             class="w-auto" pRipple>
            <i class="pi pi-question-circle mr-2"></i>
            Help
          </a>
        </li>
        <li class="flex align-items-center">
          <label [hideOnOutsideClick]="true" class="w-auto flex align-items-center cursor-pointer" enterActiveClass="px-scalein"
                 enterFromClass="ng-hidden" leaveActiveClass="px-fadeout" leaveToClass="ng-hidden"
                 pStyleClass="@next">
            {{ profile.displayName ? profile.displayName : 'Loading...' }}
            <i class="pi pi-angle-down ml-2 mt-1"></i>
          </label>

        <div class="ng-hidden">
          <ul class="list-none p-0 m-0">
            <li (click)="showProfileDialog()">
              <a
                class="cursor-pointer flex align-items-center py-2 hover:surface-hover transition-duration-150 transition-all px-3 py-2"
                pRipple>
                <i class="pi pi-cog mr-2"></i>
                <span>Profile</span>
              </a>
            </li>
            <li (click)="_authService.signOut()">
              <a
                class="cursor-pointer flex align-items-center py-2 hover:surface-hover transition-duration-150 transition-all px-3 py-2"
                pRipple>
                <i class="pi pi-power-off mr-2"></i>
                <span>Logout</span>
              </a>
            </li>
          </ul>
        </div>
        </li>
      </ul>
    </div>
  </div>
</div>
